import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    _imageControls: {
      name: 'รูปสินค้า',
      width: '6rem',
      class: 'text-center',
    },
    name: {
      name: 'ชื่อสินค้า',
      width: '10rem',
    },
    description: {
      name: 'รายเอียด',
      width: '15rem',
    },
    price: {
      name: 'ราคา',
      width: '8rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    order: {
      name: 'ลำดับการแสดงผล',
      width: '8rem',
      class: 'text-center',
    },
    // eslint-disable-next-line
    _urlControls: {
      name: 'Redirect URL',
      width: '1fr',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : 'ไม่ระบุ',
    },
    _activeControls: {
      name: 'Active',
      width: '5rem',
    },
    _favoriteControls: {
      name: 'Favorite',
      width: '5rem',
    },
  },
};
